export const environment = {
  production: false,
  baseUrl: 'https://test.website.appstore.com.ng/',
  reCaptchaKey: '6LcrnQwtAAAAAB5cvtuIntU-hCjL2SCS_hQCXpF7',
  firebaseConfig: {
    apiKey: 'AIzaSyBJ5lA8yciSljJxVEj2Qzg7vgxMv79BcdI',
    authDomain: 'http://attendanceapp-7857d.firebaseapp.com',
    projectId: 'attendanceapp-7857d',
    storageBucket: 'http://attendanceapp-7857d.appspot.com',
    messagingSenderId: '202963702968',
    appId: '1:202963702968:web:d556366e074c6cc52c504d',
    measurementId: 'G-4YFLM0WY3T',
  },
};
